import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelectChange } from '@angular/material';

/**
 * Para que el usuario pueda seleccionar el role que desea cambiar,
 * no envia peticione es solo para mostrar el select y enviar la configuracion que el componente padre enviara a la base de datos
 *
 * @export
 * @class EditRoleComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-edit-role',
    templateUrl: './edit-role.component.html',
    styleUrls: ['./edit-role.component.scss']
})
export class EditRoleComponent implements OnInit {

    member: any
    roles: Array<any> = []

    resp = {} as Response

    responseObj: {
        'newRole': string
    }

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private _dialogRef: MatDialogRef<EditRoleComponent>
    ) { }

    ngOnInit() {
        this.member = this.data['currentUser'];
        this.roles = this.data['roleList'];

        this.resp.userID = this.member.id
    }

    newRole(e: MatSelectChange) {
        this.resp.newRole = e.value;
    }

    sendResponse() {
        this._dialogRef.close(this.resp)
    }

}

interface Response {
    newRole: string;
    userID: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/pages/roles/edit-role/edit-role.component.ts